import { Grid2, Typography, Container, Box } from "@mui/material";
import { memo } from "react";
import { makeStyles } from "@mui/styles";
import logoBlack from '../assets/images/logo-black.png';

const useStyles = makeStyles(() => ({
	image: {
		width: '120px',
		height: 'auto',
	},
	typo: {
		maxWidth: '660px',
	},
}));

const Home = () => {
	const classes = useStyles();

	return (
		<Grid2 container direction="column" alignItems="center" justifyContent="center" style={{ height: "100%" }}>
			<Container maxWidth="xl" style={{ height: "100%" }}>
				<Box height="100%" display="flex" justifyContent="center" alignItems="center" flexDirection="column">
					<img src={logoBlack} alt="logo-black" className={classes.image} />
					<Box mt={2}>
						<Typography variant="h5" className={classes.typo}>{'Καλώς ήρθατε στην διαχείριση αιγοπροβατροφικών μονάδων '}<strong className={classes.typo}>{'ΑΜΝΟΣ.'}</strong></Typography>
					</Box>

				</Box>
			</Container>
		</Grid2>
	);
};

export default memo(Home);
